import RouteNames from "@/entities/RouteNames";
import BreadcrumbsTitles from "@/entities/BreadcrumbsTitles";
import { getChildRoutes } from "@/helpers/routes/getChildRoutes";
import NavigationIcons from "@/entities/NavigationIcons";
import RouteWrapper from "@/components/common/RouteWrapper.vue";
import { GetRelativeRoutes } from "@/entities/GetChildRoutes";
import Roles from "@/entities/Roles";

const DocumentsContractorAll = () =>
  import("@/views/resources/DocumentsContractorAll.vue").then((m) => m.default);
const DocumentsContractorProjects = () =>
  import("@/views/resources/DocumentsContractorProjects.vue").then(
    (m) => m.default
  );

const getDocumentsRoutes: GetRelativeRoutes = getChildRoutes([
  {
    path: "/documents",
    component: RouteWrapper,
    meta: {
      breadcrumb: {
        title: BreadcrumbsTitles.ALL_DOCUMENTS,
      },
    },
    children: [
      {
        path: "contractor/all",
        name: RouteNames.RESOURCES_DOCUMENTS,
        component: DocumentsContractorAll,
        meta: {
          title: "All Documents",
          roles: [Roles.CONTRACTOR],
          breadcrumb: {
            isStyled: true,
          },
        },
      },
      {
        path: "contractor/projects",
        name: RouteNames.RESOURCES_PROJECT_DOCUMENTS,
        component: DocumentsContractorProjects,
        meta: {
          title: "Project Documents",
          roles: [Roles.CONTRACTOR],
          breadcrumb: {
            title: BreadcrumbsTitles.PROJECTS,
            isStyled: true,
          },
        },
      },
    ],
  },
]);

export { getDocumentsRoutes };
